import React, { useEffect, useRef } from "react";

const TradingTable = () => {
  const widgetContainerRef = useRef();

  useEffect(() => {
    const existingScript = document.getElementById("trading-view-script");
    if (existingScript) {
      existingScript.parentNode.removeChild(existingScript);
    }
    const script = document.createElement("script");
    script.id = "trading-view-script";
    script.type = "text/javascript";
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-forex-cross-rates.js";
    script.async = true;
    script.innerHTML = JSON.stringify({
      width: 800,
      height: 500,
      currencies: ["EUR", "USD", "JPY", "GBP", "CHF", "AUD", "CAD", "NZD"],
      isTransparent: false,
      colorTheme: "light",
      locale: "in",
    });

    widgetContainerRef.current.appendChild(script);
    const container = widgetContainerRef.current;

    const scrollDown = () => {
      container.scrollTo({ top: container.scrollHeight, behavior: "smooth" });
    };

    const scrollUp = () => {
      container.scrollTo({ top: 0, behavior: "smooth" });
    };

    const scrollInterval = setInterval(() => {
      scrollDown();
      setTimeout(scrollUp, 2000); 
    }, 5000); 
    return () => {
      if (
        widgetContainerRef.current &&
        widgetContainerRef.current.contains(script)
      ) {
        widgetContainerRef.current.removeChild(script);
      }
      clearInterval(scrollInterval);
    };
  }, []);

  return (
    <div
      className="tradingview-widget-container"
      ref={widgetContainerRef}
      style={{ boxShadow: "0 0 20px rgba(0, 0, 0, 0.5)", overflowY: "auto" }}
    >
      <div className="tradingview-widget-container__widget"></div>
    </div>
  );
};

export default TradingTable;